export enum DEVICE_TYPE {
  CORE = "CORE",
  GUARD = "GUARD",
  BUTLER = "BUTLER",
}

export type DeviceType = `${DEVICE_TYPE}`;

export enum DEVICE_STATUS {
  NORMAL = "NORMAL",
  UPDATING = "UPDATING",
}

type DeviceStatus = `${DEVICE_STATUS}`;

export interface Device {
  deviceId: string;
  serialNumber: string;
  coreId: string;
  softwareVersion: string;
  softwareVersionAt: number;
  deviceType: DeviceType;
  hardwareVersion: string;
  tenant: string | null;
  status: DeviceStatus;
}

export interface DeviceTableRow extends Device {
  selected: boolean;
}
